<template>
  <div id="sideNav">
    <div class="item icon iconf-code"></div>
    <div class="item icon iconf-customer"></div>
    <div class="item icon iconf-pin" @click="scrollTo"></div>
  </div>
</template>

<script> 
export default {
  data() {
    return {};
  },
  methods: {
    scrollTo() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
#sideNav .item {
  padding: 10px;
  background: #3f3e3e4a;
  border-radius: 50%;
  margin-bottom: 10px;
  color: #fff;
  font-size: 20px !important;
  cursor: pointer;
}
</style>
